/**
 * The cache entry holding the signed-in user's permission list. `v2` is bumped when the shape of the
 * cached value changes, so an old persisted entry is not read as the new one.
 */
export const PERMISSIONS_QUERY_KEY = ['session', 'permissions', 'v2'] as const
